import {FC} from 'react'
import {useQuery} from 'react-query'
import {useIntl} from 'react-intl'
import {ClientEditModalForm} from './ClientEditModalForm'
import {ID, isNotEmpty, QUERIES} from '../../../helpers'
import {useListView} from '../../../../app/modules/clients/components/core/ListViewProvider'
import {getClientById} from '../../../../app/modules/clients/components/core/_requests'
import {Loading} from '../../components/loading/Loading'
import {ClientEditModalHeader} from './ClientEditModalHeader'
import {initialClient} from '../../../../app/modules/clients/components/core/_models'

type Props = {
  handleClose: () => void | undefined
  clientId: ID | undefined
  initialClientName?: string
}

const ClientEditModalFormWrapper: FC<Props> = ({handleClose, clientId, initialClientName}) => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  if (clientId !== undefined) {
    setItemIdForUpdate(clientId)
  }
  const enabledQuery: boolean = isNotEmpty(clientId)

  const {
    isLoading,
    data: response,
    error,
  } = useQuery(
    `${QUERIES.CLIENTS_LIST}-client-${clientId}`,
    () => {
      return getClientById(clientId)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        console.error(err)
      },
      refetchOnWindowFocus: false,
    }
  )

  // Prepara o cliente inicial com o nome se fornecido
  const clientWithName = initialClientName 
    ? {...initialClient, name: initialClientName}
    : initialClient

  if (!clientId) {
    return (
      <>
        <ClientEditModalHeader handleClose={handleClose} />
        <ClientEditModalForm
          isClientLoading={isLoading}
          handleClose={handleClose}
          client={clientWithName}
        />
      </>
    )
  }

  if (!isLoading && !error && response) {
    return (
      <>
        <ClientEditModalHeader handleClose={handleClose} />
        <ClientEditModalForm
          isClientLoading={isLoading}
          handleClose={handleClose}
          client={response.client}
        />
      </>
    )
  } else {
    return <Loading />
  }

  return null
}

export {ClientEditModalFormWrapper}
